module.exports = __webpack_public_path__ + "static/media/bed.2b6534a4.svg";